var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("GenericProps", {
        attrs: {
          "node-id": _vm.node.id,
          settings: _vm.settings,
          "optional-audio-parameters": _vm.optionalAudioParameters,
          parameters: _vm.genericParameters
        },
        on: {
          "update:settings": [
            function($event) {
              _vm.settings = $event
            },
            _vm.updateNodeParent
          ]
        }
      }),
      _vm._v(" "),
      _vm._l(_vm.specialParameters, function(param, idx) {
        return [
          _c(
            "div",
            {
              key: idx,
              staticClass: "cf-node-properties__field",
              class: _vm.getFieldSize(param.name)
            },
            [
              _c("label", { staticClass: "control-label" }, [
                _vm._v("\n        " + _vm._s(param.displayName) + " "),
                !param.isOptional ? _c("span", [_vm._v("*")]) : _vm._e(),
                _vm._v(" "),
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.top",
                      value: param.description,
                      expression: "param.description",
                      modifiers: { top: true }
                    }
                  ],
                  staticClass: "fa fa-question-circle m-l-5",
                  attrs: { "aria-hidden": "true" }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "cf-node-properties__input-wrapper" },
                [
                  param.type === "key" && param.keyType === "CallPlan"
                    ? _c("InputSearchableSelect", {
                        class: { "is-selected": _vm.settings[param.name] },
                        attrs: {
                          config: _vm.callPlanOptions,
                          required: !param.isOptional,
                          error: _vm.getFieldError(
                            _vm.propertyErrors,
                            param.name
                          )
                        },
                        on: { input: _vm.inputChange },
                        model: {
                          value: _vm.settings[param.name],
                          callback: function($$v) {
                            _vm.$set(_vm.settings, param.name, $$v)
                          },
                          expression: "settings[param.name]"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  param.type === "key" && param.keyType === "CallPlan"
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "cf-node-properties__input-action-button",
                          attrs: { type: "button" },
                          on: { click: _vm.triggerGetCallPlans }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-refresh",
                            class: { "fa-spin": _vm.isLoadingCallPlans },
                            attrs: { title: _vm.$t("CALL_PLANS_REFRESH") }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  param.name === "callPlanId" && _vm.settings[param.name]
                    ? _c(
                        "a",
                        {
                          staticClass: "cf-node-properties__input-action-link",
                          attrs: {
                            href: `#/dashboard/callplans/edit/${
                              _vm.settings[param.name]
                            }`,
                            target: "_blank"
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-external-link",
                            attrs: { title: _vm.$t("CALL_PLANS_VIEW_SELECTED") }
                          })
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }